import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { clearAbandonedCheckout } from '../api/public';

export default function SubscribeSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    clearAbandonedCheckout();
    const timer = setTimeout(() => navigate('/'), 4000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{ minHeight: '100vh', background: '#0f0f1a', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
      <div style={{ maxWidth: 440, width: '100%', background: '#1a1a2e', borderRadius: 16, padding: '2.5rem', border: '1px solid #2d2d44', textAlign: 'center' }}>
        <div style={{ fontSize: 56, marginBottom: '1rem' }}>🎉</div>
        <h1 style={{ color: '#f8fafc', fontSize: 26, fontWeight: 700, margin: '0 0 0.75rem' }}>
          You're in!
        </h1>
        <p style={{ color: '#94a3b8', fontSize: 15, margin: '0 0 0.5rem' }}>
          Your subscription is active. All modules are now unlocked.
        </p>
        <p style={{ color: '#475569', fontSize: 13 }}>
          Taking you to the dashboard in a moment...
        </p>
        <div style={{ marginTop: '2rem' }}>
          <button
            onClick={() => navigate('/')}
            style={{
              padding: '0.75rem 2rem', borderRadius: 10, border: 'none',
              background: '#7c3aed', color: '#fff', fontSize: 15,
              fontWeight: 600, cursor: 'pointer',
            }}
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
